import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import boxShadow from "assets/theme/functions/boxShadow";

function DataTableBodyCell({ noBorder, align, children, isPublicationColumn = false }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={1}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth }, breakpoints }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
        whiteSpace: isPublicationColumn ? "normal" : "normal", // Changed to normal
        wordBreak: isPublicationColumn ? "break-word" : "normal",
        lineHeight: isPublicationColumn ? "1.3" : "normal",
        boxShadow: "none",
        [breakpoints.up("lg")]: {
          ...(isPublicationColumn && {
            position: "sticky",
            left: 0,
            backgroundColor: "#fff",
            zIndex: 100,
            minWidth: "auto", // Changed to auto
          }),
        },
      })}
    >
      <MDBox
        display="inline-block"
        width={isPublicationColumn ? "auto" : "max-content"} // Changed to auto
        sx={{
          verticalAlign: "middle",
          boxShadow: "none",
          ...(isPublicationColumn && {
            textOverflow: "clip",
          }),
        }}
      >
        {children} 
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  isPublicationColumn: false, // Added new prop with default
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  isPublicationColumn: PropTypes.bool, // Added new prop type
};

export default DataTableBodyCell;